<template>
  <dashboard-widget title="EXCISE WAREHOUSE" no-zoom @delete="$emit('delete','DashboardExciseWarehouse')" :width="width" :enableDelete="enableDelete">
    <v-autocomplete v-if="licenses.length > 1" :items="licenses" v-model="license" hide-details dense class="d-inline-block"
              style="position:absolute;top:40px;right:40px;width:150px" @change="draw()"/>
    <v-container class="pa-0 ma-0 pt-6" @click="$router.push({name:'ReportsView', params:{back:[{text:'Dashboard',to:{name:'Dashboard'}}]},
                                                              query:{to:`reports/excise/ReportsExciseWarehouse`}})">
      <v-row class="mt-12 mx-1">
        <v-col cols="5" class="py-3 pr-0 text-body-2">Spirits > 7%</v-col>
        <v-col class="text-right py-3">{{summary.laa | number(3)}} LAA</v-col>
      </v-row>
      <v-row class="mt-6 mx-1">
        <v-col cols="5" class="py-3 pr-0 text-body-2">Spirits &lt;= 7%</v-col>
        <v-col class="text-right py-3">{{summary.litres | number(3)}} litres</v-col>
      </v-row>
    </v-container>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardExciseWarehouse',
  props: {
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      laa: [],
      license: null,
      licenses: [],
      summaries: [],
      summary: {}
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B262:true});
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardExciseWarehouse {
                                            exciseWarehouseSummary {
                                              license,laa,litres
                                            }
                                          }`, {});
      if (!results.error) {
        this.licenses = [...new Set(this.sites.map(site => site.warehouseLicense))];
        this.license = this.licenses[0];
        this.summaries = results.data.exciseWarehouseSummary;
      }
      this.draw();
    },
    draw() {
      this.summary = this.summaries.find(s => s.license === this.license) || {litres:0,laa:0};
    }
  }
}
</script>